import { render, staticRenderFns } from "./PosLayout.vue?vue&type=template&id=187f3cd0&scoped=true&"
import script from "./PosLayout.vue?vue&type=script&lang=js&"
export * from "./PosLayout.vue?vue&type=script&lang=js&"
import style0 from "./PosLayout.vue?vue&type=style&index=0&id=187f3cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f3cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VDialog,VMain})
